// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"188":"e38f0d72","856":"a811bad5"}[chunkId] + ".js";
};